module.exports = __webpack_public_path__ + "img/bg.632ef180.svg";